import { styled } from '@ori-ui/mui';

import { MobileOfficeRoot } from '../styles';

export const IconRoot = styled('div')(({ theme }) => ({
  fontSize: '3rem',
  width: '26px',
  height: '26px',
  display: 'flex',
  alignItems: 'center',
}));
export const Root = styled(MobileOfficeRoot)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  gap: theme.spacing(3),
  cursor: 'pointer',
  padding: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
